import env from '@eneco/common/env';

import { FIRST_PARTY_GTM_HOST_SUFFIXES } from '../constants';

export const isFirstPartyGtmHost = (): boolean => {
  const host = env('HOST');
  if (!host) return false;

  let hostname: string;
  try {
    hostname = new URL(host).hostname;
  } catch {
    return false;
  }

  return FIRST_PARTY_GTM_HOST_SUFFIXES.some(
    suffix => hostname === suffix || hostname.endsWith(`.${suffix}`),
  );
};
